import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "block-content pt-4 pr-4"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "p-4"
};
const _hoisted_4 = {
  key: 0,
  class: "block-content py-2",
  style: {
    "clear": "both"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "mb-5"
};
const _hoisted_6 = {
  class: "flex"
};
const _hoisted_7 = {
  class: "p-4 w-full",
  style: {
    "background-color": "#f6f9f3"
  }
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 2,
  class: "italic"
};
const _hoisted_11 = {
  class: "flex flex-col"
};
const _hoisted_12 = {
  class: "flex justify-between"
};
const _hoisted_13 = {
  class: "p-2 italic"
};
const _hoisted_14 = {
  class: "pr-10 flex-none"
};
const _hoisted_15 = {
  class: "bg-gray-100 p-4"
};
const _hoisted_16 = {
  class: "float-right"
};
const _hoisted_17 = {
  class: "table",
  "data-cy": "invoice-detail-table"
};
const _hoisted_18 = {
  class: "text-gray-400"
};
const _hoisted_19 = {
  class: "table-number"
};
const _hoisted_20 = {
  class: "table-number"
};
const _hoisted_21 = {
  class: "table-number"
};
const _hoisted_22 = {
  class: "table-number"
};
const _hoisted_23 = {
  class: "table-number"
};
const _hoisted_24 = {
  class: "table-number"
};
const _hoisted_25 = {
  class: "table-number"
};
const _hoisted_26 = {
  class: "table-number"
};
const _hoisted_27 = {
  class: "table",
  "data-cy": "invoice-total-table"
};
const _hoisted_28 = {
  class: "table-number"
};
const _hoisted_29 = {
  class: "table-number"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "table-number"
};
const _hoisted_32 = {
  class: "table-number"
};
const _hoisted_33 = {
  class: "table-number"
};
const _hoisted_34 = {
  class: "table-number"
};
const _hoisted_35 = {
  class: "table-number"
};
const _hoisted_36 = {
  class: "button-row top-margin"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return _openBlock(), _createElementBlock("div", {
    class: "ts modal-wrapper",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
    style: {
      "z-index": "9999"
    },
    "data-cy": "invoice-summary-modal"
  }, [_createElementVNode("div", {
    class: "ts modal wide",
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", {
    "data-cy": "close-invoice-summary-modal",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleCloseButton()),
    width: "14",
    height: "14",
    class: "close-btn float-right cursor-pointer",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [...(_cache[8] || (_cache[8] = [_createElementVNode("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#727272"
  }, [_createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2"
  }), _createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  })], -1)]))])), !$data.loading ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Invoice Summary")) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("h4", _hoisted_3, [...(_cache[9] || (_cache[9] = [_createElementVNode("img", {
    src: "/img/ajax-loader.gif"
  }, null, -1)]))], 512), [[_vShow, $data.loading]]), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.showValue ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.loadingValue ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[10] || (_cache[10] = [_createElementVNode("img", {
    src: "/img/ajax-loader.gif"
  }, null, -1), _createTextVNode(" Creating value statement", -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($data.value), 1)), $data.valueError ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_cache[11] || (_cache[11] = _createElementVNode("span", {
    class: "fa fa-warning"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.valueError), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $options.getInvoiceValue())
  }, [...(_cache[12] || (_cache[12] = [_createElementVNode("span", {
    title: "Regenerate the summary",
    class: "ml-2 p-2 fa fa-refresh text-lg text-center rounded shadow-sm hover:bg-gray-200 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
  }, null, -1)]))])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[14] || (_cache[14] = _createTextVNode(" AI Generated ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Auto-summary uses AI to summarize your invoice. Results should be considered a first draft and it is strongly recommended that all auto-summaries are reviewed and approved manually before being shared with clients in any capacity. ", -1)]))]),
    _: 1
  })]), _withDirectives(_createElementVNode("div", _hoisted_14, [_cache[18] || (_cache[18] = _createElementVNode("span", {
    class: "italic"
  }, "Was this useful?", -1)), _createElementVNode("span", {
    onClick: _cache[2] || (_cache[2] = $event => $options.feedback(+1)),
    title: "This mostly captured the value of the work going into this invoice"
  }, [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
    class: "ml-2 p-2 fa fa-smile-o text-sm text-center rounded hover:bg-gray-200 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out cursor-pointer border-gray-400 text-primary"
  }, null, -1)]))]), _createElementVNode("span", {
    onClick: _cache[3] || (_cache[3] = $event => $options.feedback(0)),
    title: "This didn't really capture value of the work going into this invoice"
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("span", {
    class: "ml-2 p-2 fa fa-meh-o text-bold text-sm text-center rounded hover:bg-gray-200 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out cursor-pointer border-gray-400 text-yellow-500"
  }, null, -1)]))]), _createElementVNode("span", {
    class: "",
    onClick: _cache[4] || (_cache[4] = $event => $options.feedback(-1)),
    title: "The text was not at all characterizing the value of the invoice to the point of being misleading"
  }, [...(_cache[17] || (_cache[17] = [_createElementVNode("span", {
    class: "ml-2 p-2 fa fa-frown-o text-bold text-sm text-center rounded hover:bg-gray-200 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out cursor-pointer border-gray-400 text-error"
  }, null, -1)]))])], 512), [[_vShow, !$data.loadingValue]])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("span", null, [_createElementVNode("b", null, _toDisplayString($options.headerText), 1)], 512), [[_vShow, !$data.invoicesSummary.invoice.accounting]]), _withDirectives(_createElementVNode("span", null, [_cache[19] || (_cache[19] = _createTextVNode(" Invoice ", -1)), _createElementVNode("b", null, " #" + _toDisplayString($data.invoicesSummary.invoice?.reference), 1)], 512), [[_vShow, $data.invoicesSummary.invoice.accounting]]), _createElementVNode("span", _hoisted_16, " Date " + _toDisplayString(_ctx.formatDate($data.invoicesSummary.invoice.invoiceDate)), 1)]), _createElementVNode("table", _hoisted_17, [_cache[21] || (_cache[21] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "User"), _createElementVNode("th", {
    class: "table-number text-gray-400"
  }, "Non-Billable"), _createElementVNode("th", {
    class: "table-number"
  }, "Fixed Fee"), _createElementVNode("th", {
    class: "table-number"
  }, "Billable"), _createElementVNode("th", {
    class: "table-number"
  }, "Amount")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.invoicesSummary.hours.accounts, (user, name) => {
    return _openBlock(), _createElementBlock("tr", {
      key: name
    }, [_createElementVNode("td", _hoisted_18, _toDisplayString(user.account.initials || user.account.name), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.hoursDecimal(user.nonBillableHours)), 1), _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.hoursDecimal(user.fixedHours)), 1), _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.hoursDecimal(user.billableHours)), 1), _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.amountNoZero(user.amount)), 1)]);
  }), 128))]), _createElementVNode("tfoot", null, [_createElementVNode("tr", null, [_cache[20] || (_cache[20] = _createElementVNode("td", null, [_createElementVNode("b", null, [_createElementVNode("i", null, "Hours Total")])], -1)), _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.hoursDecimal($data.invoicesSummary.hours.total.nonBillableHours)), 1), _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.hoursDecimal($data.invoicesSummary.hours.total.fixedHours)), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.hoursDecimal($data.invoicesSummary.hours.total.billableHours)), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.hours.total.amount)), 1)])])]), _createElementVNode("table", _hoisted_27, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[22] || (_cache[22] = _createElementVNode("td", null, "Fixed Fees Total", -1)), _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.totals.charges)), 1)]), _createElementVNode("tr", null, [_cache[23] || (_cache[23] = _createElementVNode("td", null, "Expenses", -1)), _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.totals.expenses)), 1)]), $data.invoicesSummary.invoice.adminFee ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [_createElementVNode("td", null, _toDisplayString($data.invoicesSummary.invoice.adminFeeLabel), 1), _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.adminFee / 100 * $data.invoicesSummary.hours.total.amount)), 1)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("tr", null, [_cache[24] || (_cache[24] = _createElementVNode("td", null, "Credits", -1)), _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.totals.credit)), 1)], 512), [[_vShow, $data.invoicesSummary.invoice.totals.credit]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.invoicesSummary.invoice.totals.taxComponents || [], component => {
    return _openBlock(), _createElementBlock("tr", {
      key: component.name
    }, [_createElementVNode("td", null, _toDisplayString(component.name), 1), _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.amountNoZero(component.amount)), 1)]);
  }), 128)), _withDirectives(_createElementVNode("tr", null, [_cache[25] || (_cache[25] = _createElementVNode("td", null, "Tax", -1)), _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.totals.tax)), 1)], 512), [[_vShow, $data.invoicesSummary.invoice.totals.tax && !($data.invoicesSummary.invoice.totals.taxComponents || []).length]])]), _createElementVNode("tfoot", null, [_createElementVNode("tr", null, [_cache[26] || (_cache[26] = _createElementVNode("td", null, [_createElementVNode("b", null, [_createElementVNode("i", null, "Invoice Total")])], -1)), _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.amountNoZero($data.invoicesSummary.invoice.totals.amount)), 1)])])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_LlSecondaryButton, {
    onClick: _cache[5] || (_cache[5] = $event => $options.exportExcel())
  }, {
    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createElementVNode("span", {
      class: "fa fa-table mr-2"
    }, null, -1), _createTextVNode(" Export ", -1)]))]),
    _: 1
  }), _cache[28] || (_cache[28] = _createElementVNode("div", {
    class: "clear"
  }, null, -1))])])) : _createCommentVNode("", true)])]);
}